import { render, staticRenderFns } from "./gscInvoiceDetail.vue?vue&type=template&id=ccab1b5e"
import script from "./gscInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./gscInvoiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports